import { defineFcm } from '../shared/factory';

export const FCM_PSF_SOCIAL_STARTER_FIRST_STEP_ENABLED = defineFcm('psf_social_starter_first_step_enabled')
	.asBoolean()
	.withDefault(false)
	.toConfig({
		owner: 'squad-narwhal',
		scope: 'corgi-middle-end',
		context: 'Combo (promote_or_share) page',
		description:
			'Routes eligible Social Starter signers (isSocialStarter && !isHelloCitizen) from promote_or_share to the Social Starter first PSF step. Off = Social Starters stay on combo.',
	});
